import React, { Component } from 'react';
// import language from "../../assets/languages/language";
import { Button, Modal, ModalBody } from 'reactstrap';
import App_data from '../../views/config/App_data';
class PaymentModalComponent extends Component {
  constructor(props) {
    super(props);
    // console.log("******", props);

    this.state = {};
  }

  static contextTypes = {
    router: React.PropTypes.object,
  };
  toggleAlert(e) {
    e.preventDefault();
    this.props.toggleAlert(e);
  }

  goPremium(e) {
    e.preventDefault();
    this.props.goPremium(e);
  }
  handleAction = (MessageContent, e) => {
    // console.log("work handleAction", MessageContent);
    if (this.props.MessageContent === 'Payment Successful') {
      // console.log("if");

      this.context.router.push({
        pathname: `/thankyou/${this.props.order_id}`,
        state: {
          token: this.props.token,
          idname: this.props.idname,
          order_id: this.props.order_id,
          China_price: this.props.China_price,
          canadian_price: this.props.canadian_price,
        },
      });
    } else {
      // console.log("else if");

      this.context.router.push({
        pathname: '/cart/',
        state: {
          token: this.props.token,
          idname: this.props.idname,
        },
      });
    }
  };
  render() {
    const { alert_status } = this.props;
    const { MessageContent } = this.props;
    const { imageName } = this.props;
    const { Trans_id } = this.props;
    const { button } = this.props;
    const { message } = this.props;
    const { classid } = this.props;
    // console.log("type", typeof classid);
    return (
      <Modal
        isOpen={alert_status}
        toggle={this.toggleAlert.bind(this)}
        className={`modal-primary custom_modalpro info-modal-designing${this.props.className}`}
      >
        <ModalBody className='text-center payment-section-wrap'>
          <div className='modal-info-view-for-plan '>
            <img
              src={`${App_data.frontend_url}/img/${imageName}`}
              className='margin_bottom_30'
              alt=''
            />

            <h4 className='margin_bottom_10'>{MessageContent}</h4>
            <div className='margin_bottom_20'>
              {message}
              The transaction ID for this payment is{' '}
              <span className={`transation-id id-${classid}`}>{Trans_id}.</span>{' '}
            </div>
            <div className='btn-plan-view view-plan-wrap'>
              <Button
                className={`btn-transation btn-${classid} margin_right_20`}
                onClick={this.handleAction.bind(this, MessageContent)}
              >
                {' '}
                {button}
              </Button>
            </div>
          </div>
        </ModalBody>
      </Modal>
    );
  }
}

export default PaymentModalComponent;



// WEBPACK FOOTER //
// ./src/views/Common/paymentModel.js